import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unit10-conclusion',
  templateUrl: './unit10-conclusion.component.html',
  styleUrls: ['./unit10-conclusion.component.css']
})
export class Unit10ConclusionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
